import React from 'react'
import { Avatar, Box, Flex, Popover, PopoverTrigger, PopoverContent, PopoverBody, Text } from '@chakra-ui/core'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { UserSummary } from 'components/ui/UserPopover/UserSummary'
import { isRtlSelector } from 'redux/selectors/general'

interface WatchersAvatarsProps {
  watcherIds: string[]
  maxVisible?: number
  avatarSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export const WatchersAvatars: React.FC<WatchersAvatarsProps> = ({ watcherIds, maxVisible = 5, avatarSize = 'sm' }) => {
  const { retailUsersObject } = useSelector((state: RootState) => state.config.config)
  const isRtl = useSelector(isRtlSelector)

  if (!watcherIds || watcherIds.length === 0) {
    return null
  }

  const visibleWatchers = watcherIds.slice(0, maxVisible)
  const remainingCount = watcherIds.length - maxVisible

  const getCalculatedMargin = (index: number) => {
    if (isRtl) {
      return visibleWatchers.length - 1 === index ? '0' : '-8px'
    }
    return index === 0 ? '0' : '-8px'
  }

  return (
    <Popover trigger="hover" placement="top">
      <PopoverTrigger>
        <Box cursor="pointer" display="inline-block">
          <Flex alignItems="center" justifyContent="center" style={{ gap: '0' }}>
            {visibleWatchers.map((uid, index) => {
              const user = retailUsersObject?.[uid]
              const userName = user?.first_name || user?.last_name || 'User'

              return (
                <Avatar
                  key={uid}
                  size={avatarSize}
                  name={userName}
                  src={user?.profile_img_url}
                  border="2px solid white"
                  zIndex={visibleWatchers.length - index}
                  ml={getCalculatedMargin(index)}
                  flexShrink={0}
                />
              )
            })}
            {remainingCount > 0 && (
              <Text fontSize="12px" color="gray.500">
                +{remainingCount}
              </Text>
            )}
          </Flex>
        </Box>
      </PopoverTrigger>
      <PopoverContent minW="300px" maxW="400px" w="max-content">
        <PopoverBody p={0} maxH="300px" overflowY="auto">
          {watcherIds.map((uid) => (
            <UserSummary key={uid} uid={uid} />
          ))}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
